<template>
  <div class="password-input">
    <div class="form-group has-input-group" v-bind:class="{ 'has-feedback' : field.dirty }">
      <label v-bind:for="field.name" class="col-sm-4 control-label has-icon has-icon-password">{{ field.label }}</label>
      <div class="col-sm-8">
        <div class="input-group">
          <input v-bind:id="field.name" class="form-control" v-bind:type="type" v-model="field.value" v-bind:name="field.name"/>
          <span class="input-group-btn">
            <button class="btn btn-info" type="button" v-on:click="togglePasswordVisibility()" data-placement="top" title="Toggle Password Visibility">
              &nbsp;
              <span class="fa" v-bind:class=" { 'fa-eye' : type == 'password', 'fa-eye-slash' : type == 'text'}"></span>
              &nbsp;
            </button>
          </span>
        </div>
        <span class="form-validation-error" v-show="!isLength && field.dirty">{{ field.label }} needs to be at least 6 characters long.</span>
        <span class="fa fa-check form-control-feedback form-control-feedback-success" v-show="field.valid && field.dirty"></span>
        <span class="fa fa-remove form-control-feedback form-control-feedback-error" v-show="!field.valid && field.dirty"></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PasswordInput',
  props: {
    field: {
      type: Object,
      default () {
        return {
          value: '',
          valid: false,
          dirty: false
        }
      }
    }
  },
  data () {
    return {
      type: 'password',
      isLength: false
    }
  },
  watch: {
    'field.value': function (newVal, oldVal) {
      if (oldVal === '') this.field.dirty = true
      this.isLength = this.field.valid = newVal.length > 5
    }
  },
  methods: {
    togglePasswordVisibility: function (field, e) {
      if (this.type === 'password') this.type = 'text'
      else this.type = 'password'
    }
  }
}
</script>



// WEBPACK FOOTER //
// PasswordInput.vue?49908e41